// Copyright (c) 2021 Davide Gironi
// Please refer to LICENSE file for licensing information.

import React from 'react';
import ReactDOM from 'react-dom';

// import bootstrap css
import 'bootstrap/dist/css/bootstrap.min.css';

// import bootstrap css
import './index.css';

// import language configuration
import './i18n';

// import main app
import App from './App';

// render mail app
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
